import React from 'react';

interface PdfViewerProps {
  base64Data: string;
  height?: string;
  width?: string;
}

const PdfViewer: React.FC<PdfViewerProps> = ({
  base64Data,
  height = '100%',
  width = '100%',
}) => {
  if (!base64Data) {
    return (
      <div className="text-gray-500 dark:text-gray-300 flex h-full items-center justify-center">
        No hay documento disponible
      </div>
    );
  }

  const isFullDataUri = base64Data.startsWith('data:application/pdf;base64,');

  return (
    <iframe
      title="PDF Viewer"
      src={
        isFullDataUri ? base64Data : `data:application/pdf;base64,${base64Data}`
      }
      width={width}
      height={height}
      className="h-full w-full border-none"
      allow="fullscreen"
    />
  );
};

export default PdfViewer;
